const RECENTLY_VIEWED_STORAGE_KEY = 'dawn:recently-viewed';
const RECENTLY_VIEWED_MAX_ITEMS = 20;

class RecentlyViewedStorage {
  static getHandles() {
    try {
      const handles = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_STORAGE_KEY) || '[]');
      return Array.isArray(handles) ? handles : [];
    } catch {
      return [];
    }
  }

  static track(handle) {
    if (!handle) return;

    const handles = this.getHandles().filter((item) => item !== handle);
    handles.unshift(handle);
    localStorage.setItem(
      RECENTLY_VIEWED_STORAGE_KEY,
      JSON.stringify(handles.slice(0, RECENTLY_VIEWED_MAX_ITEMS))
    );
  }
}

function getCurrentProductHandle() {
  const productInfo = document.querySelector('product-info[data-url]');
  if (!productInfo?.dataset.url) return null;

  const match = productInfo.dataset.url.match(/\/products\/([^/?#]+)/);
  return match ? match[1] : null;
}

function getCurrentProductId() {
  const productInfo = document.querySelector('product-info[data-product-id]');
  return productInfo?.dataset.productId || null;
}

function trackRecentlyViewedProduct() {
  const handle = getCurrentProductHandle();
  if (handle) RecentlyViewedStorage.track(handle);
}

function reorderRecentlyViewedGrid(grid, handles) {
  const list = grid.querySelector('ul');
  if (!list) return;

  const items = Array.from(list.querySelectorAll('[data-product-handle]'));
  handles.forEach((handle) => {
    const item = items.find((element) => element.dataset.productHandle === handle);
    if (item) list.appendChild(item);
  });
}

function getRecentlyViewedHandles(limit, excludeCurrentProduct) {
  let handles = RecentlyViewedStorage.getHandles();

  if (excludeCurrentProduct) {
    const currentHandle = getCurrentProductHandle();
    if (currentHandle) handles = handles.filter((handle) => handle !== currentHandle);
  }

  return handles.slice(0, limit);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', trackRecentlyViewedProduct);
} else {
  trackRecentlyViewedProduct();
}

window.RecentlyViewedStorage = RecentlyViewedStorage;
window.getRecentlyViewedHandles = getRecentlyViewedHandles;
window.reorderRecentlyViewedGrid = reorderRecentlyViewedGrid;
